import { css } from "@emotion/react";
import t from "../../theme";

const useStyles = () => {
  const pageWrapper = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "calc(100vh - 80px)",
    padding: "40px 20px",
  });

  const card = css({
    background: t.glass.primary,
    backdropFilter: t.blur.heavy,
    WebkitBackdropFilter: t.blur.heavy,
    border: t.border.base,
    borderRadius: t.radius.lg,
    boxShadow: t.shadow.md,
    padding: "48px 40px",
    maxWidth: "520px",
    width: "100%",
    textAlign: "center",
    transition: t.transition.smooth,
  });

  const iconWrapper = css({
    width: 72,
    height: 72,
    borderRadius: t.radius.circle,
    background: "rgba(220, 53, 69, 0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 24px",
    "& svg": {
      fontSize: 36,
      color: t.brand.red,
    },
  });

  const heading = css({
    fontSize: 22,
    fontWeight: 700,
    color: t.text.primary,
    marginBottom: 12,
    letterSpacing: "-0.2px",
    lineHeight: 1.3,
  });

  const description = css({
    fontSize: 15,
    fontWeight: 400,
    color: t.text.secondary,
    lineHeight: 1.6,
    marginBottom: 32,
    maxWidth: 420,
    marginLeft: "auto",
    marginRight: "auto",
  });

  const warningHighlight = css({
    fontWeight: 600,
    color: t.text.danger,
  });

  const buttonGroup = css({
    display: "flex",
    gap: 14,
    justifyContent: "center",
    flexWrap: "wrap",
  });

  const backButton = css({
    "&&": {
      minWidth: 140,
      borderRadius: t.radius.md,
      padding: "12px 24px",
      fontSize: 15,
      fontWeight: 600,
      textTransform: "none",
      background: t.glass.heavy,
      color: t.text.primary,
      border: t.border.medium,
      boxShadow: t.shadow.xs,
      transition: t.transition.fast,
      "&:hover": {
        background: t.brand.white,
        boxShadow: t.shadow.sm,
      },
    },
  });

  const deleteButton = css({
    "&&": {
      minWidth: 140,
      borderRadius: t.radius.md,
      padding: "12px 24px",
      fontSize: 15,
      fontWeight: 600,
      textTransform: "none",
      background: t.red.gradient,
      color: t.brand.white,
      border: "none",
      boxShadow: `0 2px 8px ${t.red.glow}`,
      transition: t.transition.fast,
      "&:hover": {
        background: `linear-gradient(135deg, ${t.brand.redDark} 0%, #a71d2a 100%)`,
        boxShadow: `0 4px 14px ${t.red.glow}`,
      },
    },
  });

  /* ── Confirmation Dialog ──────────────────────────────── */
  const dialogPaper = css({
    "&&": {
      borderRadius: t.radius.lg,
      padding: "8px",
      boxShadow: t.shadow.lg,
      maxWidth: 420,
    },
  });

  const dialogTitle = css({
    "&&": {
      fontSize: 18,
      fontWeight: 700,
      color: t.text.primary,
      textAlign: "center",
      paddingBottom: 4,
    },
  });

  const dialogContent = css({
    "&&": {
      fontSize: 14,
      color: t.text.secondary,
      textAlign: "center",
      paddingTop: 0,
    },
  });

  const dialogActions = css({
    "&&": {
      justifyContent: "center",
      gap: 12,
      padding: "16px 24px 20px",
    },
  });

  const dialogCancelBtn = css({
    "&&": {
      minWidth: 100,
      borderRadius: t.radius.md,
      padding: "10px 20px",
      fontWeight: 600,
      textTransform: "none",
      background: t.glass.heavy,
      color: t.text.primary,
      border: t.border.medium,
      "&:hover": {
        background: t.brand.white,
      },
    },
  });

  const dialogConfirmBtn = css({
    "&&": {
      minWidth: 100,
      borderRadius: t.radius.md,
      padding: "10px 20px",
      fontWeight: 600,
      textTransform: "none",
      background: t.red.gradient,
      color: t.brand.white,
      border: "none",
      "&:hover": {
        background: `linear-gradient(135deg, ${t.brand.redDark} 0%, #a71d2a 100%)`,
      },
    },
  });

  return {
    pageWrapper,
    card,
    iconWrapper,
    heading,
    description,
    warningHighlight,
    buttonGroup,
    backButton,
    deleteButton,
    dialogPaper,
    dialogTitle,
    dialogContent,
    dialogActions,
    dialogCancelBtn,
    dialogConfirmBtn,
  };
};

export default useStyles;
